import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ADD_PARTICIPANT_REFERENCE_DATA } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getAddParticipantReferenceData = createAsyncThunk(
  'stop/getAddParticipantReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(ADD_PARTICIPANT_REFERENCE_DATA, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const addParticipantReferenceDataSlice = createSlice({
  name: 'stop/addParticipantReferenceDataSlice',
  initialState: null,
  reducers: {
    resetAddParticipantReferenceData: () => null,
  },
  extraReducers: {
    [getAddParticipantReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetAddParticipantReferenceData } =
  addParticipantReferenceDataSlice.actions;

export default addParticipantReferenceDataSlice.reducer;
